module.exports = __webpack_public_path__ + "img/deux.096a6ad8.png";